import { render, staticRenderFns } from "./AdviceAddDialog.vue?vue&type=template&id=c3cc6e3c"
import script from "./AdviceAddDialog.vue?vue&type=script&lang=js"
export * from "./AdviceAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports